import { COMPANY_ROLES } from '@/domains/partners/multisport/const/CompanyRole.const'

export const useCompanyRoles = () => {
  const { t } = useI18n()
  return COMPANY_ROLES.map((country: { text: string }) => ({
    ...country,
    text: t(country.text),
  }))
}
